module.exports = __webpack_public_path__ + "static/media/Money.92097efe.svg";